import * as React from "react";
import { NewsApi } from "../../../api/NewsApi";
import { INewsItem } from "../../../models/INews";
import { useAuth } from "../../../App";
import { NewsItem } from "../../NewsItem/NewsItem";
import { Faq } from "../../Faq/Faq";
import { PaginationNavigation, SpinnerWrapper } from "soprasteria-ui-library";
import { IPagination } from "soprasteria-ui-library/dist/models/IPagination";
import { IPage } from "../../../models/IPage";
import { Notifications } from "../../Notifications/Notifications";
import { WelcomeHeader } from "../../WelcomeHeader/WelcomeHeader";

export const Home: React.FunctionComponent<{}> = () => {

    const auth = useAuth();
    const newsApi = new NewsApi(auth);
    const [news, setNews] = React.useState<INewsItem[]>();
    const [newsPage, setNewsPage] = React.useState<number>(1);
    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const [isNewsLoading, setIsNewsLoading] = React.useState<boolean>(false);
    let pageSelect = {} as IPage;
    const abortController = new AbortController();

    React.useEffect(() => {
        if (auth.userRolesGroup) {
            pageSelect.pageSize = 10;
            pageSelect.pageNumber = newsPage;

            setIsNewsLoading(true);
            newsApi.getNews(pageSelect, newsResponse => {
                setNews(newsResponse.data);
                setPaginationHeader(newsResponse.paginationHeader);
                window.scrollTo(0, 0);
                setIsNewsLoading(false);
            });
        }

        return () => {
            abortController.abort();
        }
    }, [newsPage, auth.userRolesGroup]);

    return (
        <section className="row">
            <WelcomeHeader />
            <div className="col-8">
                <SpinnerWrapper isLoading={news === undefined || isNewsLoading}>
                    {news?.map((newsItem, key) => <NewsItem
                        key={key}
                        publishDate={newsItem.publishDate}
                        header={newsItem.header}
                        body={newsItem.body}
                        attachments={newsItem.attachments}
                        links={newsItem.links} />)}
                    <PaginationNavigation
                        ariaLabel="news pagination selector"
                        pagination={paginationHeader}
                        pageNeighbours={2}
                        selectedPage={page => setNewsPage(page)} />
                </SpinnerWrapper>
            </div>
            <div className="col-4">
                <Notifications />
                <Faq />
            </div >
        </section >
    );
}